/**
 * created by yxxyyxyx
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Icon, Input,Select, message, Upload, Table, Button} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {FILE_TYPE,PIC_TYPE,VIDEO_TYPE,AUDIO_TYPE} from "../../../../constants";
import {applicationName, uuid} from "../../../../utils";
import {getInfoFromLocalStorage} from "../../../../actions";
import {checkFileStatus} from "../../../../actions/upload";
import UpLoad from "./components/upload";
import request from "../../../../base/request";
import moment from 'moment'

const { TextArea } = Input;
const { Option } = Select;

export default class AddClue extends BaseComponent {
    static defaultProps = {};
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {
            clue:{
                title:'',
                type:'img',
                contacts:'',
                content:'',
                contactsWay:'',
                enclosureList:[],
                resourcePictures:[],//线索图片
                resourceVideos:[],//线索视频
                attachments:[],//附件
                submittedCompany:'',//提交单位
                submittedPeople:'',//提交人
                status:'',//状态
                accept:{
                    _id: "621df42dd74c984c988d30130",
                    fid: "0",
                    name: "宣传部",
                    status: 1,
                    deptPinYin: "xuanchuanbu",
                    createTime: 1646297550512,
                    updateTime: 1646297550512,
                }
            },
            dataSource: [
                {
                    key: '1',
                    name: '胡彦斌',
                    age: 32,
                    address: '西湖区湖底公园1号',
                },
                {
                    key: '2',
                    name: '胡彦祖',
                    age: 42,
                    address: '西湖区湖底公园1号',
                },
            ],

            state: 1,
            size: 10,
            count: 0,
            onChange: () => {
                console.log(1)
            },

        }
    }

    componentWillMount() {


    }
    sysConfigLoadOver() {
       if(this.sysConfig.operation==='add'){
           this.addClue()
       }
       //接受单位
      this.getAccept()


    }
    componentDidMount() {


    }
    editClue(){
        // let
    }
    addClue(){
            this.state.clue.title ='';
            this.state.clue.contacts ='';
            this.state.clue.content ='';
            this.state.clue.contactsWay ='';
            this.state.clue.resourceVideos ='';
            this.state.clue.resourcePictures ='';
            this.state.clue.attachments ='';
        this.state.clue.accept={
            _id: "621df42dd74c984c988d30130",
                fid: "0",
                name: "宣传部",
                status: 1,
                deptPinYin: "xuanchuanbu",
                createTime: 1646297550512,
                updateTime: 1646297550512,
        }
    }

    render() {
        let {
            operation = 'details',
            acceptDepartKey = "接受单位",
            acceptDepartShow=true,
            acceptDepartRequired = true,
            acceptDepartParam="title",
            acceptDepartPlaceholder="请输入标题",
            acceptDepartDisabled= true,


            titleKey = "线索标题",
            titleShow = true,
            titleRequired = true,
            titleParam = "title",
            titlePlaceholder= "请输入"+titleKey,

            contentShow=true,
            contentKey = "线索内容",
            contentRequired = true,
            contentParam =  "content",
            contentPlaceholder= "请输入"+contentKey,

            attachmentPicturesRequired =true,
            attachmentPicturesShow=true,
            attachmentPicturesKey="附件",


        } = this.sysConfig;
        let {clue,checkedReceive,checkedRefuse} = this.state;
        let record = this.props.record || "";
        if(record){
                this.state.clue =record
        }
        console.log(this.state.clue)
        return (
            <div class={"clue"}>
                    {acceptDepartShow&& <div style={{display:'flex',marginTop:'20px',alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{ acceptDepartRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{ acceptDepartKey}:</div>
                        <div  style={{width:'100%'}}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[acceptDepartParam]}</div>:<Select
                                value={this.state.clue.accept.name} style={{ width: "224px" }} disabled={ acceptDepartDisabled}>
                                <Option value="宣传部">宣传部</Option>
                            </Select>
                            }
                        </div>
                    </div>}
                    {titleShow&& <div style={{display:'flex',marginTop:'20px',alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{titleRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{titleKey}:</div>
                        <div  style={{width:'100%'}}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[titleParam]}</div>:<Input placeholder={ titlePlaceholder }  value={clue&&clue.title}
                                                                                                                         onChange={(e) => {
                                                                                                                             this.onChange('title', e.target.value)
                                                                                                                         }}/>}
                        </div>
                    </div>}

                  {contentShow&& <div style={{display:'flex',marginTop:'15px'}}>
                    <div style={{width:'90px'}}>{contentRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{contentKey}:</div>
                    <div style={{width:'100%'}} >
                        {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[contentParam]}</div>:    <TextArea
                            value={clue&&clue.content}
                            placeholder={ contentPlaceholder }
                            autoSize={{ minRows: 3, maxRows: 5 }}
                            onChange={(e) => {
                                this.onChange('content', e.target.value)
                            }}
                        />}

                    </div>
                </div>}
                {attachmentPicturesShow&& <div style={{display:'flex',marginTop:"15px"}}>
                    <div style={{width:'85px',}}>{attachmentPicturesRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{attachmentPicturesKey}</div>
                    <div style={{ display:"flex",flexWrap:"wrap"}}>
                        <UpLoad   imgHandleChange={this.imgHandleChange} type="2" fileList={this.state.clue.attachments}></UpLoad>
                    </div>
                </div>}
            <style>{`
            .clue .ant-input{background-color: rgba(0, 80, 179, 0.04)}
            `}</style>
            </div>

        )
    }
    onChange = (key,value) =>{
        this.state.clue[key] = value;
        this.setState({},()=>{
            console.log(this.state.clue)
        })
    };

    fileRemove = (file) => {
        let fileList = this.state.material.enclosureList.filter(item=>{
            return item.uid !== file.uid
        });
        this.state.material.enclosureList = fileList;
        this.setState({});
    };

    handlePreview = (item) => {
        let file = item;
        let index= this.state.material.enclosureList.findIndex((item,index)=>item.uid==file.uid);
        this.setState({fileEditorVisible:true,showIndex:index ,itemFile:item});
    };
     beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        // let reg=/^{1,100}$/;
        let fileName = file.name;
        if (fileName.length > 100) {
            message.error('图片名称不能超过100个字符');
        }
        if (!isJpgOrPng) {
            message.error('只能上传JPG/PNG文件！');
        }
        return isJpgOrPng && fileName;
    }

    getAccept(){

    }
    haveFileUplod = false;
    imgHandleChange = (info) => {
        this.haveFileUplod = true;
        console.log(info.file.status);
        let that = this;
        if (info.file.response && info.file.response.storageFile && info.file.response.storageFile.suffix && info.file.originFileObj) {
            let ext = info.file.response.storageFile.suffix;
            if (PIC_TYPE.indexOf(ext) !== -1) {
                // 获取图片像素start
                let reader = new FileReader();
                reader.readAsDataURL(info.file.originFileObj);
                reader.onload = (e) => {
                    let img = new Image();
                    img.src = reader.result;
                    // info.file.base64 = reader.result;
                    img.onload = () => {
                        let width = img.width;
                        let height = img.height;
                        info.file.width = width;
                        info.file.height = height;
                        that.setInfoList(info.file, info.fileList);
                    }
                };// 获取图片像素end
            }
            // if ([...VIDEO_TYPE, ...AUDIO_TYPE].indexOf(ext) !== -1) {
            //     // 获取音视频的时长start
            //     let fileurl = URL.createObjectURL(info.file.originFileObj);
            //     let audioElement = new Audio(fileurl);
            //     audioElement.addEventListener('loadedmetadata', function (e) {
            //         let duration = audioElement.duration;
            //         // let second = moment.duration(duration * 1000);
            //         console.log([second.hours(), second.minutes(), second.seconds()].join(':'));
            //         info.file.duration = [second.hours(), second.minutes(), second.seconds()].join(':');
            //         that.setInfoList(info.file, info.fileList);
            //     });
            //     // 获取音视频的时长end
            // }
        }

        // 获取文件base64start
        // let file = new FileCountLimiter(info.file.originFileObj);
        // let reader = new
        // 获取文件base64end


        if (info.file.status === 'done') {
            that.setInfoList(info.file, info.fileList);
            info.file.percent = 100;
            if (info.file.response.status === 200 && info.file.response.data) { // 分片
                this.checkStatusZip(info.file.response.data, () => {
                }, (data) => { // 查看分片完成
                    // let params = {
                    //     url: data.storageFile.path,
                    //     resourceName: data.storageFile.name,
                    //     fileMd5: data.storageFile.md5,
                    //     md5: data.storageFile.md5,
                    //     size: data.storageFile.size,
                    //     // taskId: this.state.taskId,
                    //     type: this.state.fileType,
                    //     // taskMenuId: this.state.menuId,
                    //     fid: this.state.currentId,
                    //     account:this.state.account,
                    // };
                })
            }
            if (info.file.response.success) { // 非分片
                // let params = {
                //     url: info.file.response.storageFile.path,
                //     resourceName: info.file.response.storageFile.name,
                //     fileMd5: info.file.response.storageFile.md5,
                //     md5: info.file.response.storageFile.md5,
                //     size: info.file.response.storageFile.size,
                //     // taskId: this.state.taskId,
                //     type: this.state.fileType,
                //     // taskMenuId: this.state.menuId,
                //     fid: this.state.currentId,
                //     account:this.state.account,
                // };
            }
        }
        this.haveFileUplod = info.fileList.some(item => item.status != 'done');
        // this.state.material.enclosureList = info.fileList;
        this.setState({})
    };

    setInfoList = (file, fileList) => {
        /**获取及接收上传文件的数据 start*/
        let {enclosureAuthor, enclosureCreateTime} = this.sysConfig;
        fileList = fileList.map(item => {
            if (item.uid === file.uid) {
                item.uid = file.uid;
                item.ext = file.response && file.response.storageFile && file.response.storageFile.suffix;
                item.url = file.response && file.response.storageFile && file.response.storageFile.path;
                item.path = file.response && file.response.storageFile && file.response.storageFile.path;
                item.name = file.response && file.response.storageFile && file.response.storageFile.name;
                // item.type = this.state.fileType === 2 ? "picture" : this.state.fileType === 3 ? 'video' : 'attachment';
                item.isChunk = false;
                item.width = file.width;
                item.height = file.height;
                item.status = file.status;
                item.percent = file.percent && file.percent;
                item.duration = file.response && file.response.storageFile && file.response.storageFile.duration;
                item.resourceId = file.response && file.response.storageFile && file.response.storageFile.resourceId;
                item.creatTime = new Date().valueOf();
                item.account = window.top.currentUser.name;
                item.departmentValue = this.state.departmentValue;//部门
                item.pageName = this.sysConfig['pageName'];
                item.duration = file.duration; // 时长
                // item.base64 = info.file.base64;
                item.tagValue = '';
                // item.tagList = new Array(...(this.state.material.tagList || []));
                // if (this.sysConfig.accessoryNameShow) {
                //     item[enclosureAuthor] = this.state.material.enclosureAuthor;
                // }
                // if (this.sysConfig.accessoryTimeShow) {
                //     item[enclosureCreateTime] = this.state.material.enclosureCreateTime;
                // }
            }
            return item;
        });
        // this.state.material.enclosureList = fileList;
        this.setState({});
        /**获取及接收上传文件的数据 start*/
    }

    //压缩包上传 检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatusZip(md5, ingCallBack, overCallBack) {
        setTimeout(() => {
            checkFileStatus(md5).then(res => {
                if (res.state !== "mergeComplete") {
                    this.checkStatusZip(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack();
            });
        }, 100);//每隔一秒钟进行检查一次
    }



  onOk=()=>{
      let btn2=this.sysConfig.btn2||{};
    this.save(btn2)

};
    temp=()=>{
        let btn1=this.sysConfig.btn1||{};
        this.save(btn1)
    }

    save(btn) {
        let { titleParam,contactsParam,contentParam, submitterParam,submitDateParam,contactsWayParam,clueTypeParam,isInterviewParam,resourcePicturesParam,resourceVideosParam,attachmentPicturesParam,

        } = this.sysConfig;
        let sysConfig = this.sysConfig;
        let url = btn.requestUrl || '';
        let contentType = btn.contentType ||"json";
        let body = {};
        let method = btn.requestMethod || 'get';
        if (url) {

            let customRequestId = btn.customRequestId || '';
            if(customRequestId&&this.props.record){
                url=url+this.props.record.id;
            }
            //标题
            if (titleParam && sysConfig['titleShow']) {
                if (!this.state.clue.title && sysConfig['titleRequired']) return message.warning(sysConfig['titlePlaceholder'] || '请填写标题！');
                body[titleParam] = this.state.clue.title;
            }

            //线索内容
            if (contentParam && sysConfig['contentShow']) {
                if (!this.state.clue.content && sysConfig['contentRequired']) return message.warning(sysConfig['contentPlaceholder'] || '请填写内容！');
                body[contentParam] = this.state.clue.content;
            }
            //当前用户
            let account = window.top.currentUser.account;
            body[submitterParam] = account;

            //当前时间
            let approvalTimeKey = submitDateParam||"submitDate"
            if (approvalTimeKey) { //审批时间
                body[approvalTimeKey] = new Date().getTime();
            }
            let statusParam = btn.statusParam;
            let statusKey = btn.statusKey
            // 1、线索 2、选题
            body[clueTypeParam] = 1;
            body[statusParam] = statusKey;
            body[isInterviewParam] = 0;
            body[resourcePicturesParam]=[];
            body[resourceVideosParam]=[];
            body[attachmentPicturesParam]=[]


            //线索图片
            // if (resourcePicturesParam && sysConfig['resourcePicturesShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['resourcePicturesRequired']) return message.warning( sysConfig['resourcePicturesText']||"请上传线索图片");
            //     body[resourcePicturesParam] = this.state.clue.resourcePictures||[];
            // }
            // //线索视频
            // if (resourceVideosParam && sysConfig['resourceVideosShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['resourceVideosRequired']) return message.warning( sysConfig['resourceVideosText']||"请上传线索视频");
            //     body[resourceVideosParam] = this.state.clue.resourceVideos||[];
            // }
            // //线索图片
            // if (attachmentPicturesParam && sysConfig['attachmentPicturesShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['attachmentPicturesRequired']) return message.warning( sysConfig['attachmentPicturesText']||"请上传线索图片");
            //     body[attachmentPicturesParam] = this.state.clue.attachmentPictures||[];
            // }
            //let
            console.log(body, 'body---------------')
            request({url:url, contentType:contentType, body,  method, callBack:(data)=>{
                  console.log(data)
                    this.complete();
                }});

        } else {
            this.complete();
        }
    }

}
